// project imports
import {
    processEntityInput as processEntityInputMain,
    processEntityOutput as processEntityOutputMain
} from 'store/serializers/fragments/main';
import { getIriFromObj } from 'utils/processors';
import { processEntityInput as processEntityInputNote, processEntityOutput as processEntityOutputNote } from 'store/app/workmgmt/note';
import { processEntityInput as processEntityInputAlarm, processEntityOutput as processEntityOutputAlarm } from 'store/app/admin/alarm';

const hasAlarmData = (values) =>
    Boolean(values) &&
    [
        '@id',
        '@type',
        'id',
        'enabled',
        'scheduleType',
        'sendAt',
        'sendTime',
        'startsAt',
        'endsAt',
        'recurrenceInterval',
        'weekDays',
        'monthDay'
    ].some((key) => key in values);

export const processEntityInput = (values) => ({
    ...values,
    ...processEntityInputMain(values),
    alarm: hasAlarmData(values?.alarm) ? processEntityInputAlarm(values?.alarm) : null,
    notes: values?.notes?.map((note) => processEntityInputNote(note))?.sort((n1, n2) => (n1.createdAt < n2.createdAt ? 1 : -1))
});

export const processEntityOutput = (values) => {
    let alarm;

    if ('alarm' in (values || {})) {
        alarm = hasAlarmData(values?.alarm) ? processEntityOutputAlarm(values?.alarm) : null;
    }

    return {
        ...values,
        ...processEntityOutputMain(values),
        id: undefined,
        files: undefined,
        followUp: 'followUp' in (values || {}) ? getIriFromObj(values.followUp) : undefined,
        responsible: 'responsible' in (values || {}) ? getIriFromObj(values.responsible) : undefined,
        alarm,
        notes:
            'notes' in (values || {}) && Array.isArray(values.notes) ? values.notes.map((note) => processEntityOutputNote(note)) : undefined
    };
};
